import React from "react";
import Fade from "@mui/material/Fade";

const experienceData = [
  {
    title: "Software Engineer",
    company: "Reputation.com",
    period: "Feb 2025 – Present",
  },
  {
    title: "Software Development Intern",
    company: "TRACT",
    period: "May 2023 – Aug 2023",
  },
  {
    title: "Graduate Teaching Assistant",
    company: "Northeastern University",
    period: "Aug 2023 – Dec 2023",
  },
];

const Experience = () => {
  return (
    <Fade in={true} timeout={3000}>
    <div style={{ paddingTop: 8 }}>
      <p className="boldsub" style={{ fontSize: "0.82em", marginBottom: 20, letterSpacing: 2, textAlign: "left" }}>
        EXPERIENCE
      </p>
      {experienceData.map((exp, index) => (
        <div key={index} style={{ marginBottom: 20, borderTop: "1px solid #333", paddingTop: 14 }}>
          <p className="intro" style={{ margin: 0, fontSize: "0.85em", textAlign: "left" }}>
            {exp.title}
          </p>
          <p className="intro" style={{ margin: "3px 0 0", fontSize: "0.78em", color: "#914244", textAlign: "left" }}>
            {exp.company}
          </p>
          <p className="intro" style={{ margin: "3px 0 0", fontSize: "0.74em", color: "grey", textAlign: "left" }}>
            {exp.period}
          </p>
        </div>
      ))}
    </div>
    </Fade>
  );
};

export default Experience;
